<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Create password</h1>
      <p>
        Please choose a secure password that is easy to remember. The password
        should not contain any parts of your name or your email address. Please
        also note the password requirements below.
      </p>

      <form
        class="form has-placeholders"
        @submit.prevent="validateBeforeSubmit"
      >
        <fieldset>
          <label class="input -spacing-static-c">
            <mask-password-toggle></mask-password-toggle>
            <input
              :class="{
                input__field: true,
                error: errors.has('newPassword')
              }"
              name="newPassword"
              type="password"
              @input="checkPassword($event)"
              placeholder="New Password*"
              v-model="newPassword"
              ref="password"
              v-validate="'required|min:10|verify_password'"
              data-vv-as="New Password"
              data-vv-validate-on="input|blur"
            />
            <span class="input__label">New Password*</span>
          </label>

          <label class="input -spacing-static-c">
            <mask-password-toggle></mask-password-toggle>
            <input
              :class="{
                input__field: true,
                error: errors.has('repeatPassword')
              }"
              name="repeatPassword"
              type="password"
              placeholder="Repeat Password*"
              @input="checkPassword($event)"
              v-model="repeatPassword"
              v-validate="'required|confirmed:password'"
              data-vv-as="password"
              data-vv-validate-on="input|blur"
            />
            <span class="input__label">Repeat Password*</span>
          </label>

          <ul class="password-requirements -spacing-b">
            <li :class="{ 'has-passed': hasMinimum }">
              <span
                class="icon"
                :class="[hasMinimum ? 'icon--check' : 'icon--close']"
              ></span
              >Minimum length 10 characters
            </li>
            <li :class="{ 'has-passed': hasNumber }">
              <span
                class="icon"
                :class="[hasNumber ? 'icon--check' : 'icon--close']"
              ></span
              >Number
            </li>
            <li :class="{ 'has-passed': hasUppercase }">
              <span
                class="icon"
                :class="[hasUppercase ? 'icon--check' : 'icon--close']"
              ></span
              >Upper-case letter
            </li>
            <li :class="{ 'has-passed': hasLowercase }">
              <span
                class="icon"
                :class="[hasLowercase ? 'icon--check' : 'icon--close']"
              ></span
              >Lower-case letter
            </li>
            <li :class="{ 'has-passed': hasSpecial }">
              <span
                class="icon"
                :class="[hasSpecial ? 'icon--check' : 'icon--close']"
              ></span
              >Special characters
            </li>
            <li :class="{ 'has-passed': passwordsMatch }">
              <span
                class="icon"
                :class="[passwordsMatch ? 'icon--check' : 'icon--close']"
              ></span
              >Passwords match
            </li>
          </ul>

          <button
            type="submit"
            class="button-primary  button-primary--black -spacing-b"
          >
            <span class="button-primary__icon icon icon--arrow-right-hair">
              <span class="loader-base button-primary__loader"></span>
            </span>

            <span class="button-primary__label">Save Password</span>
          </button>
        </fieldset>
      </form>
    </div>
  </section>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import MaskPasswordToggle from '../../components/shared/MaskPasswordToggle';

export default {
  name: 'CreatePassword',
  components: {
    MaskPasswordToggle
  },
  data: () => ({
    newPassword: '',
    repeatPassword: '',
    hasMinimum: false,
    hasNumber: false,
    hasUppercase: false,
    hasLowercase: false,
    hasSpecial: false,
    passwordsMatch: false
  }),
  methods: {
    ...mapActions(['createPassword']),
    ...mapMutations(['toggleLoader']),
    checkPassword: function(e) {
      let val = e.target.value,
        repeatPassword = document.querySelector('input[name="repeatPassword"]')
          .value;

      if (val.length >= 10) {
        this.hasMinimum = true;
      } else {
        this.hasMinimum = false;
      }

      this.hasNumber = /\d/.test(val);
      this.hasUppercase = /[A-Z]/.test(val);
      this.hasLowercase = /[a-z]/.test(val);
      this.hasSpecial = /[!@#$%^&*)(+=._-]/.test(val);

      if (this.newPassword === repeatPassword && this.newPassword !== '') {
        this.passwordsMatch = true;
      } else {
        this.passwordsMatch = false;
      }
    },
    validateBeforeSubmit() {
      let firstErrorField;
      let passwordChangeToken = this.$route.query.token;
      let payload = {
        newPassword: this.newPassword,
        passwordChangeToken: passwordChangeToken
      };
      this.$validator.validateAll().then(result => {
        if (result) {
          if (passwordChangeToken) {
            this.toggleLoader({
              loaderText: 'Loading...'
            });
            this.createPassword(payload)
              .then(() => {
                this.toggleLoader();
                this.showSnackBar({
                  type: 'is-success',
                  message: 'Successfully updated the Password!',
                  position: 'is-bottom'
                });
                this.$router.push('/account/log-in');
              })
              .catch(() => {
                this.toggleLoader();
                this.showSnackBar({
                  type: 'is-danger',
                  message: '',
                  position: 'is-bottom'
                });
                let message = document.querySelector('.snackbar > .text');
                message.innerHTML = `The system is unable to complete your request at this time. 
                Please call <nobr><a style="text-decoration:underline;color:#fff" href="tel:1-800-400-4128">800-400-4128</a></nobr> 
                to speak to a customer service concierge.`;
                this.$router.push('/');
              });
            return;
          }
          this.showSnackBar({
            type: 'is-danger',
            message: 'Please come through the link in email',
            position: 'is-bottom'
          });
        }

        firstErrorField = this.$el.querySelector(
          '[name="' + this.$validator.errors.items[0].field + '"]'
        );
        firstErrorField.focus();
      });
    },
    showSnackBar(options) {
      this.$snackbar.open(options);
    }
  }
};
</script>

<style lang="scss" scoped>
.section {
  margin-bottom: 3rem;

  @media (min-width: 1000px) {
    margin-bottom: 20rem;
  }
}

p {
  @media (min-width: 1000px) {
    max-width: 700px;
  }
}

fieldset {
  @media (min-width: 1000px) {
    max-width: 640px;
  }
}

.password-requirements {
  color: $jumbo;
  font-size: 14px;
  list-style-type: none;
  padding-left: 0;

  li {
    padding-left: 20px;
    position: relative;

    &.has-passed {
      color: green;
    }
  }

  .icon {
    position: absolute;
    top: 4px;
    left: 0;
  }
}
</style>
